import React from "react";

// eslint-disable-next-line no-shadow
// export enum Tab {
//   BASIC = 1,
//   THREE_D_SPACE = 2,
//   VH_DEFINE = 3,
//   MENU_SET = 4,
// }

interface UserTypeBadgeProps {
  userType: string;
}

export const UserTypeBadge = (props: UserTypeBadgeProps) => {
  const { userType } = props;

  return (
    <div className="flex flex-row gap-1">
      {(userType === "room") && (
        <span className="user-type-badge">
          ROOM
        </span>
      )}
      {(userType === "room" || userType === "expo") && (
        <span className="user-type-badge">
          展示会
        </span>
      )}
    </div>
  );
}